module.exports = __webpack_public_path__ + "img/congratulations.c4e8f7f3.png";